import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { AuthContext } from '../auth/context.js';
const buttonStyle = {
    padding: '0.4em 0.9em',
    fontSize: 'var(--font-size-body-sm, 0.875rem)',
    fontWeight: 500,
    color: 'var(--color-brand-green, #1B4332)',
    background: 'transparent',
    border: '1px solid var(--color-border, #E5E7EB)',
    borderRadius: 'var(--radius-button, 8px)',
    cursor: 'pointer',
};
export function SignOutButton() {
    const auth = useContext(AuthContext);
    // Render nothing outside an AuthProvider or when not signed in.
    if (auth === null || auth.status !== 'authenticated')
        return null;
    const { signOut } = auth;
    async function handleSignOut() {
        try {
            await signOut();
        }
        finally {
            window.location.assign('/login');
        }
    }
    return (_jsx("button", { type: "button", style: buttonStyle, onClick: () => void handleSignOut(), children: "Sign out" }));
}
//# sourceMappingURL=SignOutButton.js.map